import { AR_PLATFORM } from "../constants";
import { AR_SM } from "./ARSM";
import WaitSM from "./WaitSM";

export const AR_PLATFORM_SM_CONST = {
  // States
  AR_PLATFORM_ANALYSE: "AR_PLATFORM_ANALYSE",
  WEBXR: "WEBXR",
  EIGHTHWALL: "EIGHTHWALL",

  // Misc
  ID: "AR_PLATFORM_SM",
};

export const AR_PLATFORM_SM = (actions, skuId) => ({
  id: AR_PLATFORM_SM_CONST.ID,
  initial: AR_PLATFORM_SM_CONST.AR_PLATFORM_ANALYSE,
  states: {
    [AR_PLATFORM_SM_CONST.AR_PLATFORM_ANALYSE]: {
      ...WaitSM({
        conds: [
          () => actions.ARPlatform.getPlatform() !== AR_PLATFORM.INITIALIZING,
        ],
        events: [AR_PLATFORM.WEBXR, AR_PLATFORM.EIGHTHWALL, AR_PLATFORM.NONE],
      }),
      onDone: [
        {
          target: AR_PLATFORM_SM_CONST.WEBXR,
          cond: () => actions.ARPlatform.getPlatform() === AR_PLATFORM.WEBXR,
        },
        {
          target: AR_PLATFORM_SM_CONST.EIGHTHWALL,
          cond: () =>
            actions.ARPlatform.getPlatform() === AR_PLATFORM.EIGHTHWALL,
        },
      ],
    },
    [AR_PLATFORM_SM_CONST.WEBXR]: {
      ...AR_SM(actions, skuId),
    },
    [AR_PLATFORM_SM_CONST.EIGHTHWALL]: {
      ...AR_SM(actions, skuId),
    },
  },
});
